import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DEPARTMENT_TYPE_COACHTRAINING } from 'src/app/core/constants';

@Component({
    selector: 'app-coachtraining-attached',
    templateUrl: './coachtraining-attached.component.html',
    styleUrls: ['./coachtraining-attached.component.scss'],
})
export class CoachtrainingAttachedComponent implements OnInit {
    /**
     * Definição da identificão da sessão/depto Capacitação
     */
    public departmentType: string = DEPARTMENT_TYPE_COACHTRAINING;

    /**
     * Definição do parâmetro recebido via url através do menu sidebar
     */
    public sessionType;

    constructor(private route: ActivatedRoute) {
        this.route.params.subscribe((params) => (this.sessionType = params['sessionType']));
    }

    ngOnInit(): void {
        //console.log('sessionType=' + this.sessionType);
    }
}
